import { Injectable } from '@angular/core';
import { PaymentHistory } from '../core/models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentHistoryService {
  public historyList: PaymentHistory[] = [];
  public startDate: string = '';
  public endDate: string = '';
}
